import React from "react";
import Text from "./Text";

interface ToastProps {
  message: string | null;
  className?: string;
}

/** 操作を妨げない一時メッセージ (pointer-events なし) */
const Toast: React.FC<ToastProps> = ({ message, className = "" }) => {
  return (
    <div role="status" aria-live="polite" className={`pointer-events-none ${className}`}>
      {message && (
        <div className="max-w-[42rem] rounded-2xl bg-TextPrimary/90 px-6 py-4 text-center text-white shadow-[0_8px_24px_rgba(0,0,0,0.18)]">
          <Text
            as="p"
            variant="body/l"
            weight="bold"
            className="leading-normal text-balance [word-break:auto-phrase]"
          >
            {message}
          </Text>
        </div>
      )}
    </div>
  );
};

export default Toast;
